import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 8.66732H10M8 6.66732V10.6673M8.04183 4.04248L7.95817 3.95882C7.72757 3.72822 7.61227 3.61292 7.47771 3.53046C7.35842 3.45736 7.22836 3.40349 7.09231 3.37082C6.93886 3.33398 6.7758 3.33398 6.44968 3.33398H4.13333C3.3866 3.33398 3.01323 3.33398 2.72801 3.47931C2.47713 3.60714 2.27316 3.81111 2.14532 4.062C2 4.34721 2 4.72058 2 5.46732V10.534C2 11.2807 2 11.6541 2.14532 11.9393C2.27316 12.1902 2.47713 12.3942 2.72801 12.522C3.01323 12.6673 3.3866 12.6673 4.13333 12.6673H11.8667C12.6134 12.6673 12.9868 12.6673 13.272 12.522C13.5229 12.3942 13.7268 12.1902 13.8547 11.9393C14 11.6541 14 11.2807 14 10.534V6.80065C14 6.05391 14 5.68055 13.8547 5.39533C13.7268 5.14445 13.5229 4.94047 13.272 4.81264C12.9868 4.66732 12.6134 4.66732 11.8667 4.66732H9.55032C9.2242 4.66732 9.06114 4.66732 8.90769 4.63048C8.77164 4.59782 8.64158 4.54394 8.52229 4.47084C8.38773 4.38838 8.27243 4.27308 8.04183 4.04248Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFolderPlus;
